module.exports = __webpack_public_path__ + "img/nextcam-sm.5b99c759.svg";